import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PortRequestFormServiceService } from '../../service/port-request-FormService/port-request-form.service.service';

@Component({
  selector: 'app-uploadfile-validation',
  templateUrl: './uploadfile-validation.component.html',
  styleUrls: ['./uploadfile-validation.component.scss']
})
export class UploadfileValidationComponent implements OnInit {

  @ViewChild('excelFileInput', { static: true })
  excelFileInput!: ElementRef<HTMLInputElement>;

  searchForm!: FormGroup;

  validationErrors: string[] = [];
  showValidationErrors = false;
  errorFileUrl: string = '';
  selectedStartIndex: number = -1;
  isUploading = false;

  vesselList: any[] = [];
  eventList: any[] = [];

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private portRequestFormService: PortRequestFormServiceService,
    public dialogRef: MatDialogRef<UploadfileValidationComponent>
  ) {

    this.searchForm = this.fb.group({

      vesselName: ['', Validators.required],
      imo: [''],

      startEvent: ['', Validators.required],
      endEvent: ['', Validators.required],

      reportType: ['', Validators.required],
      purpose: ['', Validators.required]

    });

  }

  ngOnInit() {
    this.getVesselList();
  }

  /* ================= GET VESSEL LIST ================= */

  getVesselList() {

    this.portRequestFormService.getVessels()
      .subscribe({

        next: (res: any) => {

          this.vesselList = res?.vessels || [];

        },

        error: (err) => {
          console.error(err);
        }

      });

  }


 onStartEventChange() {

  const startIndex = this.searchForm.get('startEvent')?.value;

  this.selectedStartIndex = Number(startIndex);

  // reset end event
  this.searchForm.patchValue({
    endEvent: ''
  });

  // mark endEvent as untouched for validation UI
  this.searchForm.get('endEvent')?.markAsUntouched();

}


  getVesselEvents(imo: string) {

    this.portRequestFormService.getVesselEvents(imo)
      .subscribe({

        next: (res: any) => {

          console.log("EVENT API RESPONSE:", res);

          this.eventList = res?.data || [];

        },

        error: (err) => {
          console.error(err);
        }

      });

  }

  /* ================= FILE VALIDATION ================= */

  private validateExcel(file: File): boolean {

    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel'
    ];

    if (!file || !allowedTypes.includes(file.type)) {
      this.toastr.error('Only Excel files are allowed');
      return false;
    }

    if (file.size > 5 * 1024 * 1024) {
      this.toastr.error('File size must be less than 5MB');
      return false;
    }

    return true;

  }


  /* ================= EXCEL UPLOAD ================= */

  uploadExcel(event: any) {

    const file: File = event.target.files[0];

    if (!file) {
      this.toastr.error('Please select an Excel file');
      return;
    }

    if (!this.validateExcel(file)) return;

    this.isUploading = true;

    this.portRequestFormService.uploadMasterReportExcel(file)
      .subscribe({

        next: (res: any) => {

          this.isUploading = false;

          const response = res?.data;

          if (response?.validation_errors?.length) {

            this.validationErrors = [];

            response.validation_errors.forEach((item: any) => {

              item.errors_list.forEach((err: string) => {

                this.validationErrors.push(
                  `${item.event} (${item.report_timestamp}) : ${err}`
                );

              });

            });

            this.errorFileUrl = response.error_file_url;

            this.showValidationErrors = true;

            return;

          }

          this.toastr.success(res.message || 'Excel uploaded successfully');

          this.excelFileInput.nativeElement.value = '';

        },

        error: (err) => {

          this.isUploading = false;

          console.error(err);

          this.toastr.error('Excel upload failed');

        }

      });

  }
  onVesselChange() {

    const selectedIMO = this.searchForm.get('vesselName')?.value;

    if (!selectedIMO) return;

    const vessel = this.vesselList.find(
      v => String(v.vesselIMO) === String(selectedIMO)
    );

    if (vessel) {

      this.searchForm.patchValue({
        imo: vessel.vesselIMO
      });

      this.getVesselEvents(vessel.vesselIMO);

    }

  }

  /* ================= DOWNLOAD ERROR FILE ================= */

  downloadErrorFile() {

    if (this.errorFileUrl) {
      window.open(this.errorFileUrl, '_blank');
    }

  }


  closeErrorPopup() {
    this.showValidationErrors = false;
  }


  /* ================= DOWNLOAD REPORT ================= */

 submitSearch() {

  if (this.searchForm.invalid) {
    this.toastr.error('Please fill all fields');
    return;
  }

  const form = this.searchForm.value;

  if (Number(form.endEvent) >= Number(form.startEvent)) {
    this.toastr.error('End Event must be after Start Event');
    return;
  }

  const startEvent = this.eventList[form.startEvent];
  const endEvent = this.eventList[form.endEvent];

  const payload = {

    imo: form.imo,
    start_datetime: this.convertToISO(startEvent.report_timestamp),
    end_datetime: this.convertToISO(endEvent.report_timestamp),
    report_type: form.reportType,
    purpose: form.purpose

  };

  console.log("FINAL PAYLOAD", payload);

  this.isUploading = true;

  this.portRequestFormService.downloadMasterReportExcel(payload)
    .subscribe({
      next: (res: Blob) => {
        this.isUploading = false;

        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'master_report.xlsx';
        a.click();

        window.URL.revokeObjectURL(url);

        this.toastr.success('Report downloaded successfully');

        this.dialogRef.close();
      },
      error: (err) => {
        this.isUploading = false;
        console.error(err);
        this.toastr.error('Download failed');
      }
    });

}

  convertToISO(dateStr: string) {

    if (!dateStr) return '';

    const date = new Date(dateStr);

    return date.toISOString().slice(0, 19);

  }
  /* ================= RESET ================= */

  resetForm() {

    this.searchForm.reset();

    if (this.excelFileInput) {
      this.excelFileInput.nativeElement.value = '';
    }

  }

}